import { useStore } from '../state/store.js';

export function OfflineBadge(): JSX.Element {
  const isOffline = useStore((s) => s.isOffline);
  const cls = isOffline
    ? 'bg-amber-500 text-amber-950'
    : 'bg-emerald-600 text-emerald-50';
  return (
    <span className={`px-2 py-1 rounded text-xs font-bold ${cls}`}>
      {isOffline ? 'オフライン' : 'オンライン'}
    </span>
  );
}
